// extracted by mini-css-extract-plugin
export var cardFigure = "_a-0";
export var cardImage = "_a-2";
export var cardInner = "_a-1";
export var cardLabel = "_a-3";
export var cardPill = "_a-4";
export var cardPillActive = "_a-6";
export var cardPillSelfServe = "_a-7";
export var cardPillText = "_a-5";
export var pillGlow = "_a-8";
export var pillShimmer = "_a-9";